import { render } from "./TransportationStopsContainerComponent.vue?vue&type=template&id=87518a40&scoped=true&ts=true"
import script from "./TransportationStopsContainerComponent.vue?vue&type=script&lang=ts"
export * from "./TransportationStopsContainerComponent.vue?vue&type=script&lang=ts"

import "./TransportationStopsContainerComponent.vue?vue&type=style&index=0&id=87518a40&scoped=true&lang=scss"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87518a40"]])

export default __exports__